import { Mg75 } from './mg75'
import list_icon from '@/assets/img/device/mg75/list_icon.png'
export class Mg75Pro extends Mg75 {
  name: string = 'MG75_PRO'
  icon: string = list_icon
  width: number = 614
}
